<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { nullCoalesce, opChain } from '@collector/shared-utils'
import {
  CricketEventStatusId,
  CricketResultId,
  Participant,
} from '@collector/sportsapi-client-legacy'
import { byId, getTeamSide } from '@mobile/reusables/entityUtils'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useCricketMainResultExtractor } from '@mobile/views/Relation/Sports/Cricket/useCricketMainResultExtractor'

export default defineComponent({
  props: {
    participant: {
      type: Object as PropType<Participant>,
      required: true,
    },
  },
  setup(props) {
    const { probableEvent } = useEventInjections()
    const { extractedValues } = useCricketMainResultExtractor(
      computed(() => props.participant),
      probableEvent,
    )

    // TOOD: remove all of it bellow when we will have proper computation of main result
    const overs = computed(() => {
      return byId(props.participant.results, CricketResultId.Overs)
    })

    const currentBall = computed(() => {
      return byId(props.participant.results, CricketResultId.CurrentBall)
    })

    const isSuperOverStatus = computed(() =>
      [
        CricketEventStatusId.SuperOverHome,
        CricketEventStatusId.SuperOverAway,
      ].includes(probableEvent.value.status_id as CricketEventStatusId),
    )

    const teamSide = getTeamSide(
      probableEvent.value.participants,
      props.participant.id,
    )

    return {
      extractedValues,
      overs,
      currentBall,
      isSuperOverStatus,
      nullCoalesce,
      opChain,
      teamSide,
    }
  },
})
</script>

<template>
  <div
    class="shadow-condensed flex h-7 items-center justify-center rounded-sm p-1 text-xl font-bold text-white"
    :class="teamSide === 'home' ? 'bg-home' : 'bg-away'"
  >
    <template v-if="isSuperOverStatus">
      {{ extractedValues.overs }}.{{ extractedValues.currentBall }} Overs
    </template>
    <template v-else>
      {{
        nullCoalesce(
          opChain(overs, (v) => v.value),
          '-',
        )
      }}.{{
        nullCoalesce(
          opChain(currentBall, (v) => v.value),
          '-',
        )
      }}
      Overs
    </template>
  </div>
</template>
